module.exports = __webpack_public_path__ + "img/smis-hub-logo-mic.90095610.png";